import React from "react";
import "./myLoader.scss";
import CircularProgress, {
  circularProgressClasses,
} from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import KristiveLogo from "../../assets/kristive.svg";

// Inspired by the former Facebook spinners.
function FacebookCircularProgress(props) {
  return (
    <Box sx={{ position: "relative" }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: (theme) =>
            theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
        }}
        size={40}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={{
          color: (theme) =>
            theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
          animationDuration: "550ms",
          position: "absolute",
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        }}
        size={40}
        thickness={4}
        {...props}
      />
    </Box>
  );
}

const MyLoader = ({ height }) => {
  return (
    <div className="my-loader" style={{ height: height }}>
      <img src="" alt="" />
      {/* <FacebookCircularProgress /> */}
      <img
        src={KristiveLogo}
        alt=""
        className="skeleton"
        style={{ height: "80px", width: "80px" }}
      />
    </div>
  );
};

export default MyLoader;
